(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["media-coverage"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = "[data-media-coverage-section]";
    const variantSelector = "[data-variant-option]";

    const updateCardFromVariant = (card, option) => {
      const priceEl = card.querySelector("[data-price]");
      const compareEl = card.querySelector("[data-compare-price]");
      const viewProductEl = card.querySelector("[data-view-product]");
      const primaryImageEl = card.querySelector("[data-primary-image]");

      const variantId = option.dataset.variantId;
      const variantPrice = option.dataset.variantPrice;
      const variantComparePrice = option.dataset.variantComparePrice;
      const variantImage = option.dataset.variantImage;

      if (priceEl && variantPrice) {
        priceEl.textContent = variantPrice;
      }

      if (compareEl) {
        if (variantComparePrice) {
          compareEl.textContent = variantComparePrice;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }

      if (viewProductEl && variantId) {
        const productUrl = viewProductEl.dataset.productUrl || "";
        viewProductEl.href = `${productUrl}?variant=${variantId}`;
      }

      if (primaryImageEl && variantImage) {
        primaryImageEl.src = variantImage;
      }
    };

    const setupCard = (card) => {
      const options = Array.from(card.querySelectorAll(variantSelector));
      if (!options.length) return;

      options.forEach((option) => {
        option.addEventListener("click", () => {
          options.forEach((item) => {
            item.classList.remove("is-active");
            item.setAttribute("aria-pressed", "false");
          });
          option.classList.add("is-active");
          option.setAttribute("aria-pressed", "true");
          updateCardFromVariant(card, option);
        });
      });
    };

    const setupSwipeToScroll = (slider) => {
      let isDown = false;
      let isDragging = false;
      let startX;
      let scrollLeft;

      slider.addEventListener('mousedown', (e) => {
        isDown = true;
        isDragging = false;
        slider.classList.add('is-down');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
      });

      slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('is-down', 'is-dragging');
      });

      slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('is-down', 'is-dragging');
      });

      slider.addEventListener('mousemove', (e) => {
        if (!isDown) return;
        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX) * 2;
        if (Math.abs(walk) > 10) {
          isDragging = true;
          slider.classList.add('is-dragging');
        }
        slider.scrollLeft = scrollLeft - walk;
      });

      // Evitar cliques acidentais em links/botões ao fazer drag
      slider.addEventListener('click', (e) => {
        if (isDragging) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);
    };

    const initSection = (section) => {
      const cards = section.querySelectorAll(".media-coverage__card");
      cards.forEach((card) => setupCard(card));

      const grid = section.querySelector(".media-coverage__grid");
      if (grid) {
        setupSwipeToScroll(grid);
      }
    };

    const init = () => {
      const sections = document.querySelectorAll(sectionSelector);
      sections.forEach((section) => initSection(section));
    };

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", init);
    } else {
      init();
    }

    document.addEventListener("shopify:section:load", (event) => {
      const loadedSection = event.target;
      if (!loadedSection) return;
      if (loadedSection.matches(sectionSelector)) {
        initSection(loadedSection);
        return;
      }
      const nestedSection = loadedSection.querySelector(sectionSelector);
      if (nestedSection) {
        initSection(nestedSection);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
